var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaskgroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 647,
    height: 473,
    viewBox: "0 0 647 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_154_1857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -42,
    width: 647,
    height: 515
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    width: 563,
    height: 431,
    rx: 215.5,
    stroke: "#F2E8CF",
    strokeWidth: 84,
    strokeLinejoin: "round",
    strokeDasharray: "102 102"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_154_1857)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -34.4253,
    y: 501.208,
    width: 323.738,
    height: 765.527,
    transform: "rotate(-90 -34.4253 501.208)",
    fill: "#363635"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskgroup);
export default __webpack_public_path__ + "static/media/Mask group.2be64a0033488de7c8c3aa0e1e582081.svg";
export { ForwardRef as ReactComponent };